import * as swcHelpers from '@swc/helpers';
import { Models } from '@grandvisionhq/carts-v2';
import { getCheckoutState } from '../api/get-checkout-state.js';
import { recoverCheckout } from '../api/recover-checkout.js';

const validateCheckoutRoute = function() {
    var _ref = swcHelpers.asyncToGenerator(function*({ apolloClient , cartHash , cartId , type , pathname ,  }) {
        const validCheckoutResult = {
            isCheckoutValid: true,
            redirectUrl: ''
        };
        try {
            const { checkoutState  } = yield getCheckoutState(apolloClient, cartId, cartHash);
            if (checkoutState && checkoutState === Models.CheckoutState.Finalized) {
                const recoveredCheckout = yield recoverCheckout(apolloClient, cartId);
                if (recoveredCheckout.success) {
                    validCheckoutResult.isCheckoutValid = false;
                    validCheckoutResult.redirectUrl = `${pathname}?cartId=${recoveredCheckout.cartId}&cartHash=${recoveredCheckout.cartHash}&type=${type || ''}`;
                }
            }
            return validCheckoutResult;
        } catch (error) {
            console.error(error);
            return validCheckoutResult;
        }
    });
    return function validateCheckoutRoute(_) {
        return _ref.apply(this, arguments);
    };
}();

export { validateCheckoutRoute };
//# sourceMappingURL=validate-checkout-route.js.map
